export const FORM_FIELDS_NAMES = {
    MEDICINE_NAME: 'medicineName',
    SIG: 'sig',
    DURATION: 'duration',
    START_DATE: 'startDate',
    END_DATE: 'endDate',
    NOTE: 'note'
}